module.exports = __webpack_public_path__ + "dist/img/logo.98c3b4d5.png";